<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        How many moles of iron atoms are present in a
        <number-value :value="mass" unit="\text{g}" />
        sample of ferrocene,
        <chemical-latex content="C10H10Fe?" />
      </p>

      <calculation-input
        v-model="inputs.studentAnswer"
        prepend-text="$\text{Fe:}$"
        append-text="$\text{mol}$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import NumberValue from '../NumberValue';
import StembleLatex from '@/tasks/components/StembleLatex';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'ChemSIU131_Task9',
  components: {
    ChemicalLatex,
    CalculationInput,
    NumberValue,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        studentAnswer: null,
      },
    };
  },
  computed: {
    mass() {
      return this.taskState.getValueBySymbol('mass').content;
    },
  },
};
</script>
